import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks when the user clicks an "Open in mobile app" entry point',
  name: 'open_in_mobile_app_clicked',
  params: [
    {
      description: 'Where the "Open in mobile app" entry point was clicked from',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['help_menu', 'mobile_nav', 'banner'],
    },
  ],
};

export default META;
